import { axiosLoader } from "@fixit/utils";
import Vue from "vue";

/**
 * Eventbus to emit error messages to parent application
 * The error events are being caught in created() in 'TheFixitNoHeader.vue'
 * and emitted to parent to be displayed as a snackbar.
**/
export let AppEventbus = new Vue();

async function loadModules() {
  if (process.client && window) {
    await axiosLoader();
  }
}

/**
 * IMPORTANT!!
 * Service requires the parent application using the components to have it's axios instance correctly set up.
 */
import { User } from "../models";
import {getCookieValue} from "@fixit/utils/src";

export default async function ($axios) {

  if (!$axios) {
    await loadModules();
  }
  const _axios = $axios ? $axios : window.axios ? window.axios : null;
  const AppSvc = {
    /**
     * Fetches the currently logged in user
     *
     * @param baseUrl - axios endpoint url
     * @returns {User}
     */
    async getCurrentUser(baseUrl) {
      let result;
      try {
        await _axios.get(
          baseUrl + `/api/Authorization/get-current-user`,
          { withCredentials: true }
        ).then(res => {
          result = res
        })
          .catch(function (error) {
            console.log("Failed: ", e, result);
          });
        if (result.data && result.data.responseCode === 200) {
          return new User(result.data.dto);
        }
      } catch (e) {

      }
      return true;
    },

    async OAuthLogin(baseUrl) {
      let result;
      try {
        _axios.defaults.headers.common["Authorization"] = "";
        result = await _axios.post(
            baseUrl,
            { withCredentials: true }
        );
        if (result.data && result.status === 200) {
          _axios.defaults.headers.common["Authorization"] = `Bearer ${result.data.accessToken}`;
        }
        return result;
      } catch (e) {
        console.log("Failed: ", e);
      }
      return result;
    },

    async VippsOrGoogleLogin(baseUrl, siteId, customerId, code, controller) {
      let result;
      try {
        let queryparams = `?code=${code}${siteId ? '&siteId=' + siteId : ''}${customerId ? '&customerId=' + customerId : ''}`
        _axios.defaults.headers.common["Authorization"] = "";
        result = await _axios.get(
            baseUrl+`/api/${controller}/get-token-and-login${queryparams}`,
            { withCredentials: true }
        );
        if (result.data && result.status === 200) {
          _axios.defaults.headers.common["Authorization"] = `Bearer ${result.data.jwtToken}`;
        }
        return result;
      } catch (e) {
        console.log("Failed: ", e);
      }
      return result;
    },

    async ThirdPartyOauthLogin(baseUrl, siteId, customerId, code, source, appleUser) {
      let result;
      try {
        let queryparams = `?code=${code}${siteId ? '&siteId=' + siteId : ''}${customerId ? '&customerId=' + customerId : ''}${appleUser ? '&appleUser=' + appleUser : ''}`
        _axios.defaults.headers.common["Authorization"] = "";
        result = await _axios.get(
            baseUrl+`/api/oauth/${source}/token${queryparams}`,
            { withCredentials: true }
        );
        if (result.data && result.status === 200) {
          _axios.defaults.headers.common["Authorization"] = `Bearer ${result.data.jwtToken}`;
        }
        return result;
      } catch (e) {
        console.log("Failed: ", e);
      }
      return result;
    },
    
    /**
     * Logs out user
     *
     * @param baseUrl - axios endpoint url
     * @returns {Boolean}
     */
    async Logout(baseUrl) {
      let result;
      let oauthRefreshToken = getCookieValue('refreshTokenOauth')
      try {
        _axios.defaults.headers.common["Authorization"] = "";
        result = await _axios.post(
          baseUrl + `/api/Authorization/logout${oauthRefreshToken ? '?refreshToken=' + encodeURIComponent(oauthRefreshToken) : ''}`,
          { origin: 'fixitno' },
          { withCredentials: true }
        );
        if (result.data && result.data.responseCode === 200) {
          document.cookie = `refreshTokenOauth=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;`;
          return new User(result.data.dto);
        }
      } catch (e) {
        console.log("Failed: ", e);
      }
      return true;
    },


        /**
     * Logs out user
     *
     * @param baseUrl - axios endpoint url
     * @returns {Boolean}
     */
        async HomepageLogout(baseUrl) {
          let result;
          let oauthRefreshToken = getCookieValue('refreshTokenOauth')
          try {
            _axios.defaults.headers.common["Authorization"] = "";
            result = await _axios.post(
              `/logout${oauthRefreshToken ? '?refreshToken=' + encodeURIComponent(oauthRefreshToken) : ''}`,
              { withCredentials: true }
            );
            if (result.data && result.data.responseCode === 200) {
              document.cookie = `refreshTokenOauth=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;`;
              return new User(result.data.dto);
            }
          } catch (e) {
            console.log("Failed: ", e);
          }
          return true;
        },

    /**
     * Logs in user
     *
     * @param baseUrl - axios endpoint url
     * @param data - login credentials
     * @returns {Boolean} true/false
     *
     * @deprecated -
     * [#1] since version 1.1.0 [#2]
     * [#3] will be copletly removed in version 2.0.0
     * [#4] if a pure login is needed please implement it on your own
     * [#5] this behavior will be included in VerifyLoginStep/VerifySignupStep so we can cover all cases
     * @see VerifyLoginStep
     */
    async Login(baseUrl, data) {
      let result;
      try {
        result = await _axios.post(
          `${baseUrl}/api/Authorization/login?origin=fixitno`,
          data,
          { withCredentials: true }
        );
        if (result.data && result.data.responseCode === 200) {
          _axios.defaults.headers.common[
            "Authorization"
          ] = `Bearer ${result.data.jwtToken}`;
        }
      } catch (e) {
        console.log("Failed: ", e);
      }
      return result;
    },

    /**
     * Logs in user with mobileCode
     *
     * @param baseUrl - axios endpoint url
     * @param data - login credentials
     * @returns { Boolean } true/false
     *
     * @deprecated -
     * [#1] since version 1.1.0 [#2]
     * [#3] will be copletly removed in version 2.0.0
     * [#4] similar behavior should not be used on its own since it could cause vurnebilities
     * [#5] this behavior will be included in VerifyLoginStep/VerifySignupStep so we can cover all cases
     *
     */
    async LoginByCode(baseUrl, data) {
      let result;
      try {
        result = await _axios.post(
          `${baseUrl}/api/Authorization/login-by-code`,
          data,
          { withCredentials: true }
        );
        if (result.data && result.data.responseCode === 200) {
          _axios.defaults.headers.common[
            "Authorization"
          ] = `Bearer ${result.data.jwtToken}`;
        }
      } catch (e) {
        console.log("Failed: ", e);
      }
      return result;
    },

    /**
     * Sends verification code via sms
     *
     * @param baseUrl - axios endpoint url
     * @param data - user credentials
     * @returns {Boolean}
     *
     *
     * @deprecated -
     * [#1] since version 1.1.0 [#2]
     * [#3] will be copletly removed in version 2.0.0
     * [#4] similar behavior should not be used on its own since it could cause vurnebilities
     * [#5] this behavior will be included in VerifyLoginStep/VerifySignupStep so we can cover all cases
     */
    async SendVerificationCode(baseUrl, data) {
      let result;
      try {
        result = await _axios.post(
          `${baseUrl}/api/Authorization/send-code`,
          data,
          { withCredentials: true }
        );
      } catch (e) {
        console.log("Failed: ", e);
      }
      return result;
    },

    /**
     * Creates new customer and does an auto login
     *
     * @param baseUrl - axios endpoint url
     * @param data - user credentials
     * @returns {Boolean}
     *
     * F
     * @deprecated -
     * [#1] since version 1.1.0 [#2]
     * [#3] will be copletly removed in version 2.0.0
     * [#4] similar behavior should not be used on its own since it could cause vurnebilities
     * [#5] this behavior will be included in VerifySignupStep so we can cover all cases
     */
    async CreateProfile(baseUrl, data) {
      let response;
      try {
        response = await _axios.post(
          `${baseUrl}/api/Authorization/create-portal-profile`,
          data,
          { withCredentials: true }
        );
      } catch (e) {
        console.log("Failed: ", e);
      }
      return response;
    },
    /**
     * Creates new customer and does an auto login
     *
     * @param baseUrl - axios endpoint url
     * @param data - FixitNoUser, EmailTicket, MobileTicket, ClientIdentity, ResendCode (query, not required)
     * @returns {Boolean}
     */
    async UpdateProfile(baseUrl, data) {
      let response;
      try {
        response = await _axios.post(
          `${baseUrl}/api/Authorization/update-profile${data.resendCode ? '?resendCode=' + data.resendCode : ''}`,
          data,
          { withCredentials: true }
        );
        if (response && response.data.responseCode == 200) {
          AppEventbus.$emit("snackbar", {
            message: 'Din profil er oppdatert!',
            visible: true,
            duration: 3000,
            state: 'info'
          });
        }

      } catch (e) {
        AppEventbus.$emit("snackbar", {
          message: 'Noe gikk galt når vi forsøkte å oppdatere din profil!',
          visible: true,
          duration: 3000,
          state: 'error'
        });
      }
      return response;
    },
    /**
     * Changes the password for a user
     *
     * @param baseUrl - axios endpoint url
     * @param body, - Code, ClientIdentity, OldPassword, Password, Step
     * @returns {Boolean}
     */
    async ChangePassword(baseUrl, body,) {
      let response;
      try {
        response = await _axios.post(
          `${baseUrl}/api/Authorization/change-password`,
          body,
          { withCredentials: true }
        );
        if (response && response.data.responseCode == 200) {
          // AppEventbus.$emit("snackbar", {
          //   message: 'Ditt passord er oppdatert!',
          //   visible: true,
          //   duration: 3000,
          //   state: 'info'
          // });
        }

      } catch (e) {
        AppEventbus.$emit("snackbar", {
          message: 'Noe gikk galt når vi forsøkte å oppdatere ditt passord.',
          visible: true,
          duration: 3000,
          state: 'error'
        });
      }
      return response;
    },

    /**
     * Verifies a user's new mobile number
     *
     * @param baseUrl - axios endpoint url
     * @param data - Mobile, Code, ClientIdentity
     * @returns {Boolean}
     */
    async VerifyNewMobileNumber(baseUrl, data) { //PASS SMS OR EMAIL IN QUERY
      let response;
      try {
        response = await _axios.post(
          `${baseUrl}/api/Authorization/verify-sms-code`,
          data,
          { withCredentials: true }
        );
        if (response && response.data.responseCode === 200) {
          return response
        }

      } catch (e) {
        AppEventbus.$emit("snackbar", {
          message: 'Noe gikk galt når vi forsøkte å oppdatere din profil!',
          visible: true,
          duration: 3000,
          state: 'error'
        });
      }
      return response;
    },

    /**
     * Verifies a user's new email
     *
     * @param baseUrl - axios endpoint url
     * @param data - Email, Code, ClientIdentity
     * @returns {Boolean}
     */
    async VerifyNewEmail(baseUrl, data) { //PASS SMS OR EMAIL IN QUERY
      let response;
      try {
        response = await _axios.post(
          `${baseUrl}/api/Authorization/verify-email-code`,
          data,
          { withCredentials: true }
        );
        if (response && response.data.responseCode === 200) {
          return response
        }

      } catch (e) {
        AppEventbus.$emit("snackbar", {
          message: 'Noe gikk galt når vi forsøkte å oppdatere din profil!',
          visible: true,
          duration: 3000,
          state: 'error'
        });
      }
      return response;
    },

    /**
 * Creates new customer and does an auto login
 *
 * @param baseUrl - axios endpoint url
 * @param data - user credentials
 * @returns {Boolean}
 */
    async UpdateProfilePassword(baseUrl, data) {
      let response;
      try {
        response = await _axios.post(
          `${baseUrl}/api/Authorization/change-password`,
          data,
          { withCredentials: true }
        );
      } catch (e) {
        console.log("Failed: ", e);
      }
      return response;
    },


    /**
     * @public
     * @async
     * @function VerifyLoginStep
     * @param baseUrl - axios endpoint url
     * @param body Dictionary<string, string> contains fixed properties like username, isTpn, TpnChainId, TpnSiteId and needed data for specific step
     * @description Used to verify current step in the login process and returns nex stepp with required data.
     * @returns Returns the name of the next step in the process and additional data (if needed) for the next step
     * @since introduced in v1.1.0
     * @author Mladen Raguž
     * @todo Add recaptcha validation
     */
    async VerifyLoginStep(baseUrl, body, isVippsLogin = false, isGoogleLogin = false) {
      let response;
      try {
        response = await _axios.post(
          isGoogleLogin
          ? `${baseUrl}/api/GoogleOauth/verify-and-login`
          : `${baseUrl}/api/Authorization/verify-login-step${isVippsLogin ? '?loginSource=vipps' : ''}`,
          body,
          { withCredentials: true }
        );
      } catch (e) {
        console.log("Failed: ", e);
      }
      if(response.data.jwtToken != null) _axios.defaults.headers.common["Authorization"] = "Bearer " + response.data.jwtToken;
      return response;
    },


    //-----------------------------------------------------   NEW LOGIN   -----------------------------------------------------

    async verifySignupStep(baseUrl, payload) {
      let response;
      try {
        response = await _axios.post(
          `${baseUrl}/Authorization/verify-signup-step`,
          payload,
          { withCredentials: true }
        );
      } catch (e) {
        console.log("Failed: ", e)
      }
      if(response.data.jwtToken != null) _axios.defaults.headers.common["Authorization"] = "Bearer " + response.data.jwtToken;
      return response;
    },

    /**
     * @public
     * @async
     * @function VerifyAndLogin
     * @param baseUrl - axios endpoint url
     * @param body Dictionary<string, string> contains fixed properties like username, isTpn, TpnChainId, TpnSiteId and needed data for specific step
     * @description Used to verify email code in the vipps login process and logs the user in.
     * @returns Returns the name of the next step in the process and additional data (if needed) for the next step
     * @since introduced in v1.1.0
     * @author Mladen Raguž
     * @todo Add recaptcha validation
     */
    async VerifyAndLogin(baseUrl, body, reuseVippsEmail) {
      let response;
      try {
        response = await _axios.post(
          `${baseUrl}/api/Vipps/verify-and-login${reuseVippsEmail ? '?reuseVippsEmail=true' : '?reuseVippsEmail=false'}`,
          body,
          { withCredentials: true }
        );
      } catch (e) {
        console.log("Failed: ", e);
      }
      if(response.data.jwtToken != null) _axios.defaults.headers.common["Authorization"] = "Bearer " + response.data.jwtToken;
      return response;
    },

    /**
     * @public
     * @async
     * @function VerifyAndLogin
     * @param baseUrl - axios endpoint url
     * @param body Dictionary<string, string> contains fixed properties like username, isTpn, TpnChainId, TpnSiteId and needed data for specific step
     * @description Used to verify steps in the oauth flow and logs the user in.
     * @returns Returns the name of the next step in the process and additional data (if needed) for the next step
     * @since introduced in v2.1.0
     * @author Mladen Raguž
     */
    async VerifyOauthStep(baseUrl, body, reuseVippsEmail = false) {
      let response;
      try {
        response = await _axios.post(
          `${baseUrl}/oauth/verify-and-login${reuseVippsEmail ? '?reuseVippsEmail=true' : '?reuseVippsEmail=false'}`,
          body,
          { withCredentials: true }
        );
      } catch (e) {
        console.log("Failed: ", e);
      }
      if(response.data.jwtToken != null) _axios.defaults.headers.common["Authorization"] = "Bearer " + response.data.jwtToken;
      return response;
    },

    async CheckCustomerForGlobalProfile(baseUrl, query){
      let response;
      try {
        response = await _axios.get(
          `${baseUrl}/api/Kunde/check-customer-for-global-profile/${query.siteId}/${query.customerId}`,
          { withCredentials: true }
        );
      } catch (e) {
        console.log("Failed: ", e);
      }
      if(response.data.responseCode == 500){
        AppEventbus.$emit("snackbar", {
          message: 'Det har oppstått en uventet feil!',
          visible: true,
          duration: 3000,
          state: 'error'
        });
      }
      return response.data.dto;
    },

    async Authorize(baseUrl, path) {
      try {
        const response = await _axios.get(`${baseUrl}/authorize${path}`,  { withCredentials: true });
        
        return await response; // assuming the response is JSON
      } catch (error) {
        console.error('Error authorizing:', error);
        return undefined;
      }
    }
    
  };

  return AppSvc;
}
